import partsFormula from '@/core/components/partsFormula'
import vue from 'vue'
import store from '@/store'
const that = vue.prototype
export default {
  // 半成品
  className: 'parts',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '型号不可为空'
      ]
    },
    {
      name: 'content',
      validators: [
        (val) => val ? null : '含量不可为空'
      ]
    },
    'describe',
    {
      name: 'price',
      disabled: true
    }
  ],
  search: [
    'name'
  ],
  hooks: {
    beforeFetch ({ where }) {
      where.workShop = {
        $exists: true
      }
      if (store.state.user && store.state.user.allShopManagements === 'Yes') {

      } else {
        where.workShop = {
          $in: store.state.user.shopManagements
        }
      }
    },
    async beforeDelete ({ objectId }) {
      // 获取删除半成品之前有关此半成品的公布价
      let oriPriceGroup = []
      let priceLog = []
      let { data: a } = await that.$tkParse.post('/totalPrice/reasonParts', objectId)
      oriPriceGroup = a
      // 删除半成品，修改相应成品
      let { data: f } = await that.$tkParse.get('/classes/finishProduct', {
        params: {
          where: { partsId: { $all: [objectId] } }
        }
      })
      if (f.results.length) {
        f.results.forEach(async (g) => {
          let partsId = g.partsId.filter((gl) => { return gl !== objectId })
          let formula = g.formula.filter((gl) => { return gl.rawMaterial || gl.parts !== objectId })
          await that.$modelAjax.put('finishProduct', g.objectId, {
            partsId: partsId,
            formula: formula
          }).catch(e => {
            throw that.$notification['error']({
              message: '保存失败',
              description: '修改相应成品失败，请重新尝试'
            })
          })
        })
      }
      // await that.$tkHelper.sleep(500)
      for (let i in oriPriceGroup) {
        let { data: b } = await that.$tkParse.post('/totalPrice/totalPrice', oriPriceGroup[i].objectId)
        let log = {
          type: '',
          name: oriPriceGroup[i].name,
          user: store.state.user.name,
          reason: 'partsDeleted',
          describe: '由' + oriPriceGroup[i].price + '变为' + b
        }
        if (oriPriceGroup[i].isBatching) {
          log.type = 'batchingFinishProduct'
        } else {
          log.type = 'finishProduct'
        }
        if (oriPriceGroup[i].price !== b) { priceLog.push(log) }
      }
      that.$tkParse.post('/totalPrice/toPriceLog', priceLog)
    }
  },
  action: {
    edit: store.state.user && store.state.user.authority.parts.edit ? {} : false,
    delete: store.state.user && store.state.user.authority.parts.del ? {} : false,
    formula: store.state.user && store.state.user.authority.parts.formula
      ? {
        type: 'row',
        text: '修改配方',
        component: partsFormula
      } : false
  }
}
